var _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hearth_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    transform: "translate(1.193 2.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    d: "M295.246 577.545a6.567 6.567 0 00-8.889-.355 6.557 6.557 0 00-8.889 9.627l8.5 8.5a.547.547 0 00.771 0l8.506-8.5a6.564 6.564 0 00.001-9.272zm-.77 8.5l-8.12 8.118-8.118-8.118a5.468 5.468 0 017.734-7.732.546.546 0 00.771 0 5.468 5.468 0 017.734 7.733z",
    className: "cls-1",
    transform: "translate(-275.55 -575.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    d: "M409.144 597.4a.544.544 0 000 1.089 2.851 2.851 0 012.848 2.848.544.544 0 001.089 0 3.941 3.941 0 00-3.937-3.937z",
    className: "cls-1",
    transform: "translate(-394.112 -595.029)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_3",
    fill: "none",
    d: "M0 0h24v24H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.e8ba86c8d7d25925709c42726d10875f.svg";
export { ForwardRef as ReactComponent };